const localizers = {
  'loading.msg': () => `Caricamento...`,
  'logon.message.msg': () => `L’autenticazione è obbligatoria. Immetti ID utente e password validi.`,
  'logon.button.msg': () => `Accedi...`,
  'SASServer.logonError.msg': () => `Impossibile connettersi al server.`,
  'SASServer.genericError.msg': () => `Impossibile raggiungere il server.`,
}
export default localizers;
